import { atom } from "recoil"

// `/profile` の表示名の**未保存の入力**。`null` は「下書きが無い」。
//
// #430 が routed content に `key={currentTeam.id}` を付けたので、チームが変わると
// 開いているページが作り直されます。**表示名はユーザースコープ**で、チームが
// 変わっても入力し続けたい値なので、Form インスタンスの外に置いて再マウントを
// またがせます（#432）。
//
// **他の未保存入力をここに足さないこと。** チーム名 / 招待メール / role /
// 追加シート数 / カード番号は**チームスコープ**で、**もともと別チームの内容なので
// チーム変更で消えるのが正しい挙動**です（#432 の棚卸し）。
//
// ログアウトは `window.location.href` でページごと読み直すので、この下書きが
// 別のユーザーに残ることはありません。
const useProfileNameDraft = atom<string | null>({
  key: "profileNameDraft",
  default: null,
})

export default useProfileNameDraft
